import Button from "@common/components/Button";
import { useTranslation } from "next-i18next";

type Props = {
  onGetNotifiedClick: () => void;
};
const VehicleNoResults = ({ onGetNotifiedClick }: Props) => {
  const { t } = useTranslation(["vehiclesPage", "vehicle"]);
  return (
    <div className="flex mt-20 items-center flex-col w-full text-center">
      <h3 className="mt-2 text-text-light-100 leading-8">
        {t("vehiclesPage:no_perfect_match")}
      </h3>
      <p className="mt-2 body-3 leading-6 text-text-light-200">
        {t("vehiclesPage:sourcing_new_inventory")}
      </p>
      <p className="body-3 leading-6 text-text-light-200">
        {t("vehiclesPage:get_notified_when")}
      </p>
      <Button onClick={onGetNotifiedClick} className="mt-4">
        {t("vehicle:get_notified")}
      </Button>
    </div>
  );
};

export default VehicleNoResults;
